import template from './location.missinglatlng.html';
import controller from './location.missinglatlng.controller';
import './location.missinglatlng.scss';

let locationMissinglatlngComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template,
  controller
};

export default locationMissinglatlngComponent;


// WEBPACK FOOTER //
// ./client/app/components/location/missinglatlng/location.missinglatlng.component.js